import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Componente principal de la App (Página Raíz)
function App() {
  return (
    <div 
      className="d-flex align-items-center justify-content-center text-center" 
      style={{ 
        minHeight: '100vh', 
        backgroundColor: '#f8f9fa' 
      }}
    >
      <div className="container">
        <div className="card shadow-sm mx-auto" style={{ maxWidth: '500px' }}>
          <div className="card-body p-4 p-md-5">
            
            <h1 className="h2 fw-bold mb-3">
              LemmonTags
            </h1>
            
            <p className="text-muted">
              Bienvenido al portal de Lemmon Tags. El acceso a las herramientas y paneles se realiza a través de los enlaces de activación y consulta proporcionados con tus tags.
            </p>

            <div className="mt-4">
              <p className="small mb-2">
                Si has encontrado una mascota o un objeto, por favor escanea el código QR o utiliza el NFC del tag para acceder a su información.
              </p>
              <i className="bi bi-qr-code" style={{ fontSize: '2rem' }}></i>
            </div>

            <hr className="my-4" />

            <p className="small text-muted">
              Para más información sobre nuestros productos, visita nuestro sitio principal.
            </p>
            <a 
              href="https://lemmontags.com" 
              className="btn btn-outline-secondary btn-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visitar LemmonTags
            </a>

          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
